/* Featured-Collection Custom Scrollbar (Modern-Pattern, Desktop only)

   Injiziert eine clickable + draggable Scrollbar unter dem Slider (.slider).
   Thumb-Width = visible-portion / total-width des Sliders.
   Thumb-Position folgt scrollLeft des Sliders.
   Drag auf den Thumb scrollt den Slider proportional.
   Click auf den Track scrollt zur Click-Position.

   Greift NUR auf .slider-component-desktop > .slider (= Desktop-Slider-Mode
   in featured-collection). Auf Mobile ist's grid--peek mit kein
   slider-component-desktop class — also kein scrollbar.

   Idempotent via dataset flag. Re-runs bei shopify:section:load.
*/
(function () {
  function setupScrollbar(scope) {
    var root = scope || document;
    var sliders = root.querySelectorAll('slider-component.slider-component-desktop > .slider');
    sliders.forEach(function (slider) {
      if (slider.dataset.scrollbarSetup === 'true') return;
      slider.dataset.scrollbarSetup = 'true';

      var scrollbar = document.createElement('div');
      scrollbar.className = 'slider-scrollbar';
      var thumb = document.createElement('div');
      thumb.className = 'slider-scrollbar__thumb';
      scrollbar.appendChild(thumb);

      // Insert after the slider-component (parent), so scrollbar sits under
      // the whole slider-with-buttons block.
      var sliderComponent = slider.closest('slider-component') || slider;
      sliderComponent.parentNode.insertBefore(scrollbar, sliderComponent.nextSibling);

      var ticking = false;
      function update() {
        var totalScroll = slider.scrollWidth - slider.clientWidth;
        if (totalScroll <= 1) {
          scrollbar.style.display = 'none';
          ticking = false;
          return;
        }
        scrollbar.style.display = '';
        var trackWidth = scrollbar.clientWidth;
        if (trackWidth <= 0) { ticking = false; return; }
        var visibleRatio = slider.clientWidth / slider.scrollWidth;
        var thumbWidth = Math.max(40, trackWidth * visibleRatio);
        var ratio = slider.scrollLeft / totalScroll;
        var thumbX = (trackWidth - thumbWidth) * ratio;
        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + thumbX + 'px)';
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      }
      slider.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // Drag: mousedown on thumb -> follow mousemove -> scroll slider
      var dragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      thumb.addEventListener('mousedown', function (e) {
        e.preventDefault();
        dragging = true;
        dragStartX = e.clientX;
        dragStartScrollLeft = slider.scrollLeft;
        scrollbar.classList.add('slider-scrollbar--dragging');
        document.body.style.userSelect = 'none';
      });

      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var deltaX = e.clientX - dragStartX;
        var trackWidth = scrollbar.clientWidth;
        var thumbWidth = thumb.getBoundingClientRect().width;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        var maxThumbMove = trackWidth - thumbWidth;
        if (maxThumbMove <= 0) return;
        var scrollDelta = (deltaX / maxThumbMove) * maxScroll;
        slider.scrollLeft = dragStartScrollLeft + scrollDelta;
      });

      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        scrollbar.classList.remove('slider-scrollbar--dragging');
        document.body.style.userSelect = '';
      });

      // Click on track (not thumb): scroll to clicked position
      scrollbar.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        var rect = scrollbar.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var trackWidth = scrollbar.clientWidth;
        var thumbWidth = thumb.getBoundingClientRect().width;
        var ratio = (clickX - thumbWidth / 2) / (trackWidth - thumbWidth);
        ratio = Math.max(0, Math.min(1, ratio));
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        slider.scrollTo({ left: maxScroll * ratio, behavior: 'smooth' });
      });

      // Initial + delayed updates (images may load late)
      update();
      setTimeout(update, 200);
      setTimeout(update, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupScrollbar();
    });
  } else {
    setupScrollbar();
  }
  document.addEventListener('shopify:section:load', function (event) {
    setupScrollbar(event.target);
  });
})();
